/* HALE HERBALS — предиктивний пошук (Фаза 2).
   Один код для всіх форм [data-hale-search]:
     • .nav-search (шапка, десктоп) — панель спливає під полем;
     • .m-drawer .dsearch (бічне меню) — панель інлайн після форми;
     • .msearch-form (повноекранний оверлей, data-inline) — панель = [data-hale-search-panel]
       усередині найближчого [data-hale-search-root].
   Дані беруться з атрибутів форми (нуль хардкоду):
     data-popular="[…рядки…]"           — популярні запити (блоки секції header);
     data-states="[{title,url},…]"       — стани з metaobject hale_need;
     data-popular-collection="handle"    — колекція для «Популярних товарів».
   Стани панелі: порожній (чіпи популярного + «Популярні товари»),
   результати (колекції першими, потім товари), «нічого не знайдено» (стани + квіз + Telegram).
   Escape/скрол-лок оверлею — HALE.layers (у hale-mobile.liquid); тут — лише панель.
   Стилі: .hale-dd* (hale-ux-fixes.css) + .msr*, .hale-dd-states, .hale-dd-none (hale-nav.css).

   2026-09-10 — ПОРОЖНІЙ СТАН СКОРОЧЕНО.
   Було три секції й 22 посилання ще до введення тексту: «Популярне» (8 чіпів),
   «Популярні товари» (4) і «Або оберіть стан →» (10 чіпів). Третя секція
   дублювала чіпси станів, які тепер стоять угорі самого каталогу, і робила
   з пошуку другий каталог замість підказки, що ввести.

   Стани НЕ видалені з коду — statesBlock() далі працює у noneHTML(), де він
   справді корисний: коли за запитом нічого не знайшлось, стан — це найкраща
   наступна дія. data-states на формі теж лишається.

   2026-11-01 — КЛАВІАТУРА. Esc закриває плаваючу панель у шапці (раніше лише
   клік поза нею); ↓/↑ переходять полем → підказки → назад у поле. В оверлеї
   (data-inline) Esc і далі закриває весь оверлей через HALE.layers. */
window.HALE.ready(function () {
  'use strict';
  var H = window.HALE;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 200;
  var LIMIT = 5;          /* per resource type, what suggest.json returns */
  var MAX_ROWS = 5;       /* 2026-09-14, власник: у панелі не більше 5 підказок разом */
  var MAX_COLS = 2;       /* з них колекцій — не більше двох, решта товари */
  var POPULAR_LIMIT = 4;

  var ROOT = ((H.routes && H.routes.root) || '/').replace(/\/$/, '');
  var SEARCH_URL = (H.routes && H.routes.search) || (ROOT + '/search');
  var PREDICTIVE = (H.routes && H.routes.predictive) || (ROOT + '/search/suggest');
  if (!/\.json$/.test(PREDICTIVE)) PREDICTIVE += '.json';
  var TG = (H.contacts && H.contacts.telegram) || '';

  var popularCache = {};   /* handle → Promise<products[]> */

  function parseAttr(form, name) {
    try { var v = JSON.parse(form.getAttribute(name) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  /* suggest.json і products.json віддають ціну РЯДКОМ у гривнях ("235.00") */
  function cents(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isFinite(n) ? Math.round(n * 100) : 0;
  }
  function money(v) { var c = cents(v); return c ? H.formatMoney(c) : ''; }
  function searchHref(q) { return SEARCH_URL + '?q=' + encodeURIComponent(q) + '&type=product'; }

  function chipsHTML(list) {
    return list.map(function (q) {
      return '<a href="' + H.esc(searchHref(q)) + '">' + H.esc(q) + '</a>';
    }).join('');
  }
  function statesHTML(states) {
    return states.map(function (s) {
      return '<a href="' + H.esc(s.url) + '">' + H.esc(s.title) + '</a>';
    }).join('');
  }
  function statesBlock(states, kicker) {
    if (!states.length) return '';
    return '<span class="hale-dd-kicker">' + H.esc(kicker || 'Або оберіть стан →') + '</span>' +
           '<div class="hale-dd-chips hale-dd-states">' + statesHTML(states) + '</div>';
  }
  function productsGridHTML(products) {
    return products.map(function (p) {
      var v = p.variants && p.variants[0];
      var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var pr = v ? money(v.price) : '';
      return '<a class="hale-dd-card" href="' + H.esc(ROOT + '/products/' + encodeURIComponent(p.handle)) + '">' +
               '<div class="hale-dd-thumb">' + (img ? '<img src="' + H.esc(img) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</div>' +
               '<div><div class="hale-dd-name">' + H.esc(p.title) + '</div>' +
               (pr ? '<div class="hale-dd-price">' + pr + '</div>' : '') +
               '</div></a>';
    }).join('');
  }
  function loadPopular(handle) {
    if (!handle) return Promise.resolve([]);
    if (!popularCache[handle]) {
      popularCache[handle] = fetch(ROOT + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + POPULAR_LIMIT,
                                   { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).slice(0, POPULAR_LIMIT); })
        .catch(function () { popularCache[handle] = null; return []; });
    }
    return popularCache[handle];
  }

  function resultRowsHTML(collections, products, q) {
    var html = collections.map(function (c) {
      return '<a class="msr msr--col" href="' + H.esc(c.url) + '">' +
               '<div class="msr-img msr-img--col"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16M4 12h16M4 17h10"/></svg></div>' +
               '<div><div class="msr-n"><span class="msr-kind">Колекція</span> · ' + H.esc(c.title) + '</div></div></a>';
    }).join('');
    html += products.map(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      var pr = money(p.price);
      return '<a class="msr" href="' + H.esc(p.url) + '">' +
               '<div class="msr-img">' + (img ? '<img src="' + H.esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
               '<div><div class="msr-n">' + H.esc(p.title) + '</div>' +
               (pr ? '<div class="msr-p">' + pr + '</div>' : '') +
               '</div></a>';
    }).join('');
    html += '<a class="msearch-all" href="' + H.esc(searchHref(q)) + '">Усі результати →</a>';
    return html;
  }
  function noneHTML(q, states) {
    return '<div class="hale-dd-none">' +
      '<p class="hale-dd-none-t">За «' + H.esc(q) + '» нічого не знайшли</p>' +
      statesBlock(states, 'Оберіть стан →') +
      '<button type="button" class="hale-btn hale-btn--primary" data-open-quiz data-quiz-src="search-empty">Підібрати за 1 хвилину</button>' +
      (TG ? '<p class="hale-dd-none-tg">або напишіть нам у <a href="' + H.esc(TG) + '" target="_blank" rel="noopener">Telegram</a></p>' : '') +
    '</div>';
  }

  function build(form) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input || form.__haleDD) return;
    form.__haleDD = true;

    var popular = parseAttr(form, 'data-popular');
    var states = parseAttr(form, 'data-states');
    var popHandle = form.getAttribute('data-popular-collection') || '';

    var inline = form.hasAttribute('data-inline');
    var inDrawer = !!form.closest('.m-drawer');
    var rootEl = form.closest('[data-hale-search-root]');
    var dd = rootEl ? rootEl.querySelector('[data-hale-search-panel]') : null;
    var floating = !inline && !inDrawer;

    if (!dd) {
      dd = document.createElement('div');
      dd.className = 'hale-dd' + (inDrawer ? ' hale-dd--drawer' : '');
      dd.hidden = true;
      if (inDrawer && form.parentNode) form.parentNode.insertBefore(dd, form.nextSibling);
      else form.appendChild(dd);
    }
    dd.setAttribute('role', 'region');
    dd.setAttribute('aria-label', 'Підказки пошуку');
    if (!dd.id) dd.id = 'hale-dd-' + Math.random().toString(36).slice(2, 8);

    var timer = null, lastQuery = '', ctrl = null, idleShown = false;

    function open() { dd.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { if (!inline) { dd.hidden = true; input.setAttribute('aria-expanded', 'false'); } }
    function abort() { if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; } }

    function showIdle() {
      abort();
      lastQuery = '';
      if (idleShown && dd.getAttribute('data-state') === 'idle') { open(); return; }
      idleShown = true;
      dd.setAttribute('data-state', 'idle');
      /* Секція станів тут НЕ малюється — див. коментар у шапці файлу. */
      dd.innerHTML =
        (popular.length ? '<span class="hale-dd-kicker">Популярне</span><div class="hale-dd-chips">' + chipsHTML(popular) + '</div>' : '') +
        (popHandle ? '<div class="hale-dd-sep"></div><span class="hale-dd-kicker">Популярні товари</span><div class="hale-dd-grid" data-pop><div class="hale-dd-load">Завантаження…</div></div>' : '');
      open();
      loadPopular(popHandle).then(function (products) {
        var slot = dd.querySelector('[data-pop]');
        if (!slot) return;
        if (!products.length) { var k = slot.previousElementSibling; if (k && k.classList.contains('hale-dd-kicker')) k.remove(); slot.remove(); return; }
        slot.innerHTML = productsGridHTML(products);
      });
    }

    function render(d, q) {
      var res = (d && d.resources && d.resources.results) || {};
      var cols = (res.collections || []).slice(0, MAX_COLS);
      var prods = (res.products || []).slice(0, Math.max(0, MAX_ROWS - cols.length));
      dd.setAttribute('data-state', (cols.length || prods.length) ? 'results' : 'none');
      dd.innerHTML = (cols.length || prods.length) ? resultRowsHTML(cols, prods, q) : noneHTML(q, states);
      open();
      H.track('search_suggest', { q: q, products: prods.length, collections: cols.length });
    }

    function search(q) {
      abort();
      ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var url = PREDICTIVE + '?q=' + encodeURIComponent(q) +
                '&resources[type]=product,collection&resources[limit]=' + LIMIT +
                '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title';
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          render(d, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          dd.setAttribute('data-state', 'error');
          dd.innerHTML = '<p class="msearch-empty">Не вдалося завантажити, спробуйте ще</p>' +
                         '<a class="msearch-all" href="' + H.esc(searchHref(q)) + '">Шукати на сторінці →</a>';
          open();
        });
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    /* Фаза B: комбобокс — панель підказок оголошена, її стан видно читачу екрана */
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('aria-controls', dd.id);
    input.setAttribute('aria-expanded', inline ? 'true' : 'false');

    input.addEventListener('focus', function () {
      if (input.value.trim().length < MIN_CHARS) showIdle();
      else open();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN_CHARS) { showIdle(); return; }
      if (q === lastQuery) { open(); return; }
      lastQuery = q;
      dd.setAttribute('data-state', 'loading');
      dd.innerHTML = '<div class="hale-dd-load">Пошук…</div>';
      open();
      timer = setTimeout(function () { search(q); }, DEBOUNCE_MS);
    });

    form.addEventListener('submit', function (e) {
      if (input.value.trim().length < 1) { e.preventDefault(); input.focus(); return; }
      H.track('search_submit', { q: input.value.trim(), source: inline ? 'overlay' : (inDrawer ? 'drawer' : 'header') });
    });

    /* 2026-11-01: клавіатура — див. шапку файлу */
    function items() {
      return Array.prototype.slice.call(dd.querySelectorAll('a[href], button'))
        .filter(function (el) { return el.offsetParent !== null; });
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !inline && !dd.hidden) {
        e.preventDefault(); e.stopPropagation(); close();
      } else if (e.key === 'ArrowDown' && !dd.hidden) {
        var list = items();
        if (list.length) { e.preventDefault(); list[0].focus(); }
      }
    });
    dd.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Escape') return;
      var list = items(), i = list.indexOf(document.activeElement);
      if (e.key === 'Escape') {
        if (inline) return;
        e.preventDefault(); e.stopPropagation(); close(); input.focus();
        return;
      }
      e.preventDefault();
      if (e.key === 'ArrowDown') { if (list[i + 1]) list[i + 1].focus(); }
      else if (i <= 0) input.focus();
      else list[i - 1].focus();
    });

    /* плаваюча панель у шапці закривається кліком поза нею */
    if (floating) {
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target) && !dd.contains(e.target)) close();
      });
      form.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !form.contains(e.relatedTarget) && !dd.contains(e.relatedTarget)) close();
      });
    }
    /* у шухляді панель не мала жодного «закрити»: після першого тапу в поле
       блок «Популярне» лишався назавжди, навіть після закриття шухляди (B03) */
    if (inDrawer) {
      form.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !form.contains(e.relatedTarget) && !dd.contains(e.relatedTarget)) close();
      });
      H.on('hale:layer', function (e) {
        var d = e && e.detail;
        if (d && d.id === 'menu' && !d.open) close();
      });
    }
    /* клік по «Підібрати» з панелі — ховаємо панель, квіз відкриє hale-modals */
    dd.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-quiz]')) close();
    });
  }

  document.querySelectorAll('[data-hale-search]').forEach(build);
});
